import { NodeTypeDeterminer, NodeTypeVisitor } from './node-type';
import { setCursorOnTag, activateEditor, setTextCursor } from './cursor-utils';
import { Editor } from './editor';

export class CursorSet {
  private readonly nodeManager: NodeTypeDeterminer;
  

  constructor(nodeManager: NodeTypeDeterminer) {
    this.nodeManager = nodeManager;
  }

  //returns true if set to cell
  setCursor(node: Node, right: boolean): boolean {
    const setter = new CursorSetter(right, true, (n, r) => {
      return this.setCursor(n, r);
    });

    return this.nodeManager.determineType(node, setter);
  }

  setCursorKeepingNode(node: Node, right: boolean): boolean {
    const setter = new CursorSetter(right, false, (n, r) => {
      return this.setCursorKeepingNode(n, r);
    });

    return this.nodeManager.determineType(node, setter);
  }
}

class CursorSetter implements NodeTypeVisitor<boolean>{

  private readonly right: boolean;
  private readonly setAtRightSiblingOfTag: boolean;

  private readonly cursorSetter: (node: Node, right: boolean) => boolean;


  constructor(right: boolean, setAtRightSiblingOfTag: boolean, setCursor: (node: Node, right: boolean) => boolean) {
    this.right = right;
    this.setAtRightSiblingOfTag = setAtRightSiblingOfTag;

    this.cursorSetter = setCursor;
  }

  visitServiceBreak(node: HTMLBRElement): boolean {
    setCursorOnTag(node);
    return false;
  }

  visitCell(id: string, editor: Editor): boolean {
    activateEditor(editor, this.right);
    return true;
  }

  visitText(node: Text): boolean {
    const text = node.textContent;
    if (text) {
      setTextCursor(node, this.right ? text.length : 0);
    }

    return false;
  }

  visitDelimiter(n: HTMLSpanElement): boolean {
    if (this.setAtRightSiblingOfTag) {
      return this.setCursorOnTagorNextSibling(n);
    }
    else {
      setCursorOnTag(n);
      return false;
    }
  }

  visitLineBreak(n: HTMLBRElement): boolean {
    if (this.setAtRightSiblingOfTag) {
      return this.setCursorOnTagorNextSibling(n);
    }
    else {
      setCursorOnTag(n);
      return false;
    }
  }

  private setCursorOnTagorNextSibling(node: Node): boolean {
    if (!this.right) {
      setCursorOnTag(node as Element);
      return false;
    }
    else {
      const next = node.nextSibling;
      if (next) {
        return this.cursorSetter(next, false);
      }
    }

    return false;
  }
}